// Template font loading (§11.2 B6): Google Fonts css2 hrefs declared by a
// manifest are injected once, when that template becomes active. Classic
// declares none (index.html already loads Inter + Montserrat for everyone).

const loaded = new Set<string>()

export function ensureTemplateFonts(hrefs: readonly string[] | undefined): void {
  if (!hrefs?.length || typeof document === 'undefined') return
  for (const href of hrefs) {
    if (loaded.has(href) || document.querySelector(`link[data-st-font="${CSS.escape(href)}"]`)) {
      loaded.add(href)
      continue
    }
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    link.dataset.stFont = href
    document.head.appendChild(link)
    loaded.add(href)
  }
}
